import BasicProfileCard from "components/Cards/basicProfileCard";
import ProfileCard from "components/Cards/profileCard";
import OverViewCarousal from "components/CustomWidgets/overViewCarousal";
import "./style.scss";
import {
  useCareerMatches,
  useProfessionalMatches,
  useProfileMayLike,
  useRecentlyViewed,
} from "hooks/api/useExplore";
import { useContext } from "react";
import { ExploreContext } from "context/ExploreContext";

function MoreMatches() {
  const { setTabActive, setSelectedList, tabActive } =
    useContext(ExploreContext);
  // recently viewed profiles
  const { data, isLoading } = useRecentlyViewed({
    see_all: true,
  });
  const recentlyViewed = data?.recently_viewed || data?.users_data || [];

  // Careermatches profiles
  const { data: careerMatchesData, isLoading: careerMatchesLoading } =
    useCareerMatches({
      see_all: true,
    });
  const careerMatches =
    careerMatchesData?.career_matches || careerMatchesData?.users_data || [];

  // professionalmatches profiles
  const {
    data: professionalMatchesData,
    isLoading: professionalMatchesLoading,
  } = useProfessionalMatches({
    see_all: true,
  });
  const professionalMatches =
    professionalMatchesData?.professional_matches ||
    professionalMatchesData?.users_data ||
    [];

  //ProfileMayLike
  const { data: profileMayLikeList, isLoading: profileMayLikeLoading } =
    useProfileMayLike({
      limit: 4,
    });
  const profileMayLike =
    profileMayLikeList?.profiles_you_may_like ||
    profileMayLikeList?.users_data ||
    [];

  const renderBasicProfileCard = (item) => (
    <BasicProfileCard
      profile={item}
      key={item.id}
      snippetProfileId={item.id}
      snippetProfileName={item.name}
      snippetImage={item.profile_image}
      snippetProfileAge={item.age}
      snippetProfileHeight={item.height}
      snippetProfileJob={item.profession}
      snippetVisible={
        item?.is_private === true && item?.allow_image_view === false
      }
      snipperVerification={item?.verification_type}
      snippetPremium={item?.is_premium_member}
      snippetInterestSent={item?.has_expressed_interest}
      snippetFav={item?.has_favorited}
      snippetRecommended={item?.isSuggest}
      snippetImageRequested={item?.image_requested}
      aec_id={item?.aec_id}
      tabVariant={tabActive || "6"}
      selectedList={item.selectedList}
    />
  );

  return (
    <div className="flex flex-col gap-16 pl-10 pt-3 more-matches-tab">
      <OverViewCarousal
        isLoading={isLoading}
        carousalClass="recently-carousal"
        cardTitle="Recently viewed"
        cardDesc="Profiles that you recently viewed."
        slidesToShow={4}
        seeAllBtn
        seeAllClick={() => {
          setSelectedList(1);
          setTabActive("7");
        }}
        carousalData={recentlyViewed?.map((item) => ({
          ...item,
          selectedList: 1,
        }))}
        renderItem={renderBasicProfileCard}
        carousalResponsive={[
          {
            breakpoint: 1277,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1086,
            settings: {
              slidesToShow: 2.5,
            },
          },
          {
            breakpoint: 912,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1.8,
            },
          },
        ]}
      />
      <OverViewCarousal
        isLoading={careerMatchesLoading}
        carousalClass="recently-carousal"
        cardTitle="Career matches"
        cardDesc="Personalized matches based on your preferences."
        slidesToShow={4}
        seeAllBtn
        seeAllClick={() => {
          setSelectedList(2);
          setTabActive("7");
        }}
        carousalData={careerMatches?.map((item) => ({
          ...item,
          selectedList: 2,
        }))}
        renderItem={renderBasicProfileCard}
        carousalResponsive={[
          {
            breakpoint: 1277,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1086,
            settings: {
              slidesToShow: 2.5,
            },
          },
          {
            breakpoint: 912,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1.8,
            },
          },
        ]}
      />
      <OverViewCarousal
        isLoading={professionalMatchesLoading}
        carousalClass="recently-carousal"
        cardTitle="Professional matches"
        cardDesc="Find matches with similar career and educational backgrounds."
        slidesToShow={4}
        seeAllBtn
        seeAllClick={() => {
          setSelectedList(3);
          setTabActive("7");
        }}
        carousalData={professionalMatches?.map((item) => ({
          ...item,
          selectedList: 3,
        }))}
        renderItem={renderBasicProfileCard}
        carousalResponsive={[
          {
            breakpoint: 1277,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1086,
            settings: {
              slidesToShow: 2.5,
            },
          },
          {
            breakpoint: 912,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 820,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1.8,
            },
          },
        ]}
      />
      <div className={profileMayLike.length > 0 ? "outer-container" : ""}>
        <OverViewCarousal
          isLoading={profileMayLikeLoading}
          carousalClass="profiles-like-carousal"
          cardTitle="Profiles you may like"
          cardDesc="Suggested matches based on your interests and compatibility."
          slidesToShow={1.1}
          carousalData={profileMayLike}
          renderItem={(item, index) => (
            <ProfileCard
              profile={item}
              key={index}
              snippetProfileId={item?.id}
              profileImage={item?.profile_image}
              userName={item?.name}
              imageCount={item?.image_count}
              lastSeen={item?.last_seen}
              userAge={item?.age}
              profileId={item?.aec_id}
              userHeight={item?.height}
              religion={item?.religion}
              profession={item?.profession}
              maritalStatus={item?.marital_status}
              livesIn={item?.lives_in}
              primaryLanguage={item?.primary_language}
              createdBy={item?.created_for}
              menuDrop={false}
              verificationType={item?.verification_type}
              isPremium={item?.is_premium_member}
              isFavorite={item?.has_favorited}
              isNotInterested={item?.has_expressed_not_interest}
              isInterested={item?.has_expressed_interest}
              aec_id={item?.aec_id}
              isPrivate={item?.is_private}
              photoReqByMe={item?.image_requested}
              tabActive={tabActive || "6"}
            />
          )}
        />
      </div>
    </div>
  );
}

export default MoreMatches;
